import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  TemplateRef,
  Renderer2
} from '@angular/core';
import { TooltipOptions, TOOLTIP_OPTIONS } from '../../models/tooltip-options';
import { PositionService } from '../../services/position.service';

@Component({
  selector: 'muni-gameday-tooltip-container',
  templateUrl: './tooltip-container.template.html',
  styleUrls: ['./tooltip-container.styles.scss'],
  standalone: false,
})
export class TooltipContainerComponent implements AfterViewInit {
  public classMap: any;
  // Removed top, left, display properties; will set styles directly for CSP compliance
  public content: string;
  public htmlContent: string | TemplateRef<any>;
  private placement: string;
  private popupClass: string;
  private animation: boolean;
  private appendToBody: boolean;
  private hostEl: ElementRef;
  public context: any;

  public constructor(
    private element: ElementRef,
    private cdr: ChangeDetectorRef,
    private positionService: PositionService,
    private renderer: Renderer2,
    @Inject(TOOLTIP_OPTIONS) options: TooltipOptions
  ) {
    Object.assign(this, options);
    this.classMap = { in: false, fade: false };
    this.classMap[options.placement] = true;
    this.classMap['tooltip-' + options.placement] = true;
  }

  public ngAfterViewInit(): void {
    const position = this.positionService.positionElements(
      this.hostEl.nativeElement,
      this.element.nativeElement.children[0],
      this.placement,
      this.appendToBody
    );
    // Set styles directly using Renderer2 to avoid CSP issues
    const tooltipEl = this.element.nativeElement.children[0];
    this.renderer.setStyle(tooltipEl, 'top', `${position.top}px`);
    this.renderer.setStyle(tooltipEl, 'left', `${position.left}px`);
    this.renderer.setStyle(tooltipEl, 'display', 'block');
    this.classMap.in = true;
    if (this.animation) {
      this.classMap.fade = true;
    }
    if (this.popupClass) {
      this.classMap[this.popupClass] = true;
    }
    this.cdr.detectChanges();
  }

  public get isTemplate(): boolean {
    return this.htmlContent instanceof TemplateRef;
  }
}
